import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Button, Col, Row, Modal } from "react-bootstrap";
import logo from "../Images/logo.svg";
import { FcGoogle } from "react-icons/fc";
import "./Navbar.css";

const Ai = () => {
  return (
    <>
      <Row
        className="d-flex justify-content-center mx-md-0 mt-md-5 mt-2 mb-md-5 mb-2 mx-2 m-md-0 m-2"
        style={{ height: "" }}
      >
        <Col md={10}>
          <Row className="mt-md-5 mt-2 mb-md-5 mb-2">
            <Col
              md={6}
              className="d-flex flex-column justify-content-center align-items-start"
            >
              <div>
                <h2 style={{ fontSize: "rem", color: "#00013C" }}>
                  <b>
                    Optimize, <span style={{ color: "#3C74F6" }}>Innovate</span>{" "}
                    & Succeed with
                    <br />
                    <span style={{ color: "#3C74F6" }}>AI powered</span>{" "}
                   
                  </b>
                </h2>

                <p
                  className="mt-3"
                  style={{
                    color: "#00013C",
                    fontSize: "1rem",
                    fontWeight: "500",
                  }}
                >
                  Hey! with Bix AI, we're all about making SEO easy and
                  effective. Whether you're running a blog, managing a business,
                  or just trying to get your website noticed, we've got the
                  AI-driven tools to help you shine online.
                </p>
                <div className="mt-4 d-flex gap-3">
                  <Button
                    style={{
                      backgroundColor: "#fff",
                      color: "#0D0D26",
                      border: "2px solid #3C74F6",
                      fontWeight: 600,
                      padding: "10px 20px",
                      fontSize: "1rem",
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <FcGoogle size={20} />
                    <span>Start free with Google</span>
                  </Button>

                  <Button
                    style={{
                      backgroundColor: "#fff",
                      color: "#0D0D26",
                      border: "2px solid #3C74F6",
                      fontWeight: 600,
                      padding: "10px 20px",
                      fontSize: "1rem",
                    }}
                  >
                    Book a Demo
                  </Button>
                </div>
              </div>
            </Col>
            <Col
              md={6}
              className="d-flex justify-content-center align-items-center"
              style={{ height: "100%" }}
            >
              <img
                src={require("../Images/ai.png")}
                alt="Tool"
                style={{ height: "40vh" }}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default Ai;
